"use client";

import { createLogger } from "@/lib/logger";
import { useSearchParams } from "next/navigation";
import { Suspense, useEffect } from "react";

const logger = createLogger("CouponTracker");

function CouponTrackerInner() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const coupon = searchParams?.get("coupon");
    if (coupon) {
      // Set cookie to expire in 30 days
      const days = 30;
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = "; expires=" + date.toUTCString();

      // Cookie is accessible on all paths
      document.cookie = "coupon_code=" + (coupon || "") + expires + "; path=/; SameSite=Lax";

      logger.info("Coupon code persisted", { coupon });
    }
  }, [searchParams]);

  return null;
}

export function CouponTracker() {
  return (
    <Suspense fallback={null}>
      <CouponTrackerInner />
    </Suspense>
  );
}
